// extracted by mini-css-extract-plugin
module.exports = {"captureQr":"captureQr_captureQr__18nMX","modalBody":"captureQr_modalBody__kUUMB","error":"captureQr_error__HcRjC","cameraImageView":"captureQr_cameraImageView__3IlaN"};